export enum VoiceAuthenticationStatus {
    AUTHENTICATED = 'Authenticated',
    NOTAUTHENTICATED = 'Not Authenticated',
    MISSINGPATRONID = 'Missing Patron ID',
}